"use client";

import * as ProgressPrimitive from "@radix-ui/react-progress";
import * as React from "react";

import { cn } from "../lib/utils";

interface ProgressProps
	extends React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root> {
	indeterminate?: boolean;
}

const Progress = (
    {
        ref,
        className,
        value,
        indeterminate,
        ...props
    }: ProgressProps & {
        ref: React.RefObject<React.ElementRef<typeof ProgressPrimitive.Root>>;
    }
) => (<ProgressPrimitive.Root
    ref={ref}
    className={cn(
        "relative h-4 w-full overflow-hidden rounded-full bg-secondary",
        className,
    )}
    {...props}
>
    <ProgressPrimitive.Indicator
        className={cn(
            "h-full w-full flex-1 bg-primary transition-all",
            indeterminate && "animate-progress origin-left",
        )}
        style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
    />
</ProgressPrimitive.Root>);
Progress.displayName = ProgressPrimitive.Root.displayName;

export { Progress };
